<script setup lang="ts">
const props = defineProps({
  loading: { type: Boolean, default: false },
  type: { default: '' },
  text: null,
  justify: { default: 'center' },
  disabled: { type: Boolean, default: false },
  textLoading: null,
  textColor: null,
  auth: { type: Boolean, default: false },
  round: { type: Boolean },
  isIcon: { type: Boolean },
  isActive: { type: Boolean },
  hideBorder: { type: Boolean }
})
const emits = defineEmits(['click'])
const userStore = useUserStore()
const { isLogin } = storeToRefs(userStore)

const BG_MAP: any = computed(() => {
  return {
    default: `text-white dark:text-brand brand-gradient ${props.loading ? 'hover:none' : 'sm:hover:from-[#FF2541] sm:hover:to-[#FF9A02] sm:hover:dark:bg-white sm:hover:dark:bg-none active:from-[#FF2541] active:to-[#FF9A02] active:dark:bg-white active:dark:bg-none'}`,
    cancel: `bg-brandB bg-op-10 dark:bg-white dark:bg-op-10 text-brandB dark:text-white ${props.loading ? '' : '!hover:bg-brandB !hover:bg-op-20 hover:dark:!bg-white hover:dark:!bg-op-20'}`,
    gray: 'bg-brandB bg-op-10 !hover:bg-brandB !hover:bg-op-20 hover:dark:bg-white hover:dark:bg-op-8 dark:bg-white dark:bg-op-8',
    delete: `bg-delete text-white ${props.loading ? '' : 'hover:b hover:b-delete hover:bg-white hover:text-delete hover:dark:b-none'}`,
    ghost: 'hover:bg-brandB hover:bg-op-20 hover:dark:!bg-white hover:dark:!bg-op-5',
    border: 'font-bg',
    white: 'bg-white hover:bg-brandB hover:bg-op-15',
  }
})
const JUSTIFY_MAP: any = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
}
const randomID = ref('')

const setIconBg = () => {
  const box = document.getElementById(randomID.value)
  if (!box) return

  const el = box.querySelector('div')
  if (!el) return

  if (props.loading && !['default', 'gray', 'ghost', 'border'].includes(props.type)) {
    el.style.background = isDark.value ? '#fff' : ''
  } else if (props.disabled && !['default'].includes(props.type)) {
    el.style.background = 'rgba(138, 150, 163,.4)'
  } else {
    el.style.background = ''
  }
}
watch(props, () => {
  setIconBg()
})

const clickHandle = () => {
  if (props.loading) return
  if (props.disabled) return
  if (props?.auth && !isLogin.value) {
    Session.set('redirectUri', window.location.href)
    GlobalThis.$loginModalNew.openModal()
    // if (isMobile()) {
    //   let query = {}
    //   if (route.name === 'Creators') {
    //     query = {
    //       domain: route.params.domain,
    //     }
    //   }
    //   router.push({ name: 'LoginPhone', query })
    // } else {
    //   GlobalThis.$loginModalNew.openModal()
    // }
  } else {
    emits('click')
  }
}

onMounted(() => {
  nextTick(() => {
    randomID.value = Math.random().toString(36).substr(2, 9)
    setTimeout(() => {
      setIconBg()
    }, 200)
  })
})
</script>

<template>
  <div
    v-if="type === 'borderBg'"
    @click="clickHandle"
    :class="`relative borderBg mb-4 overflow-hidden h-10 rounded-2 w-full ${loading || disabled ? '' : 'btnBG'} ${disabled ? 'b-brandB b-op-30 cursor-not-allowed' : 'dark:b-brandB dark:b-op-25'} ${loading ? 'cursor-wait' : 'cursor-pointer'}`"
  >
    <div class="w-full h-full bg-white dark:bg-bgBrand">
      <div
        v-if="loading"
        class="w-full h-full bg-brandB bg-op-30 absolute-center absolute-center z-1"
      />
      <div class="itemBg15 relative h-full flex items-center px-2 typeface-robotoMedium">
        <slot>
          <img
            v-if="loading"
            src="@/assets/image/loading.png"
            class="w-6 h-6 mr-2 loadingRotate"
            alt="dfans"
          />
          <span
            :class="`${disabled ? 'text-brandB' : textColor ? textColor : 'font-bg'}`"
            class="text-center"
          >
            {{ loading ? textLoading || text : text }}
          </span>
        </slot>
      </div>
    </div>
  </div>
  <div
    v-else-if="type === 'border'"
    :class="`${hideBorder ? '' : 'bg-transparent b-1'} text-sm cursor-pointer typeface-robotoMedium relative select-none cursor-pointer overflow-hidden ${round ? 'rounded-full' : 'rounded-md'} ${loading || disabled ? '' : hideBorder ? '' : 'btnBG'} ${disabled ? 'b-brandB b-op-30 cursor-not-allowed' : 'dark:b-brandB dark:b-op-25'} ${loading ? 'cursor-wait' : 'cursor-pointer'} ${isActive ? 'activeBtn' : ''}`"
    @click="clickHandle"
  >
    <div
      v-if="loading"
      class="w-full h-full bg-brand bg-op-25 absolute-center absolute-center z-1"
    />
    <div
      :class="`flex items-center ${loading || disabled ? 'text-white dark:text-brandB bg-brandB bg-op-30' : 'itemRow'} ${JUSTIFY_MAP[justify]} w-full h-full ${isIcon ? '' : 'px-2 sm:px-3'} ${isActive ? 'itemBg' : ''}`"
    >
      <span v-if="!loading" :id="randomID">
        <slot name="icon" />
      </span>
      <slot>
        <img
          v-if="loading"
          src="@/assets/image/loading.png"
          class="w-6 h-6 mr-2 animate-spin"
          alt="dfans"
        />
        <span v-if="loading" :id="randomID">
          <slot name="icon" />
        </span>
        <span
          :class="`${disabled ? 'text-white dark:text-brandB' : textColor ? textColor : 'font-bg'}`"
          class="text-center"
        >
          {{ loading ? textLoading || text : text }}
        </span>
      </slot>
    </div>
  </div>
  <div
    v-else
    class="overflow-hidden typeface-robotoMedium text-sm relative select-none"
    :class="`${JUSTIFY_MAP[justify]} ${loading ? 'cursor-wait' : 'cursor-pointer'} ${round ? 'rounded-full' : 'rounded-md'} ${disabled ? 'cursor-not-allowed text-brandB !bg-brandB !bg-op-30' : type && BG_MAP[type]}`"
    @click="clickHandle"
  >
    <div
      v-if="loading"
      class="w-full h-full bg-brand bg-op-25 absolute-center absolute-center z-10"
    />
    <div class="px-2 sm:px-3 w-full !h-full iconBox">
      <div class="flex items-center h-full" :class="`${JUSTIFY_MAP[justify]}`">
        <span v-if="!loading" :id="randomID">
          <slot name="icon" />
        </span>
        <slot>
          <span class="w-max flex items-center text-center">
            <img
              v-if="loading"
              src="@/assets/image/loading.png"
              class="w-6 h-6 mr-2 animate-spin"
              alt="dfans"
            />
            <span v-if="loading" :id="randomID">
              <slot name="icon" />
            </span>
            <span
              :class="`${['gray', 'ghost', 'white'].includes(type) && !disabled ? 'font-bg' : ''} ${textColor}`"
            >
              {{ loading ? textLoading || text : text }}
            </span>
          </span>
        </slot>
      </div>
    </div>
    <!-- 按钮点击水波纹效果 -->
    <BtnClickWave />
  </div>
</template>

<style lang="less" scoped>
.borderBg {
  border: solid 1px transparent;
  background-origin: border-box;
  background-clip: content-box, border-box;
  background-image: linear-gradient(#fff, #fff), linear-gradient(90deg, #ff3c73, #ffbb00);
}

.borderBg:hover {
  .itemBg15 {
    background: linear-gradient(90deg, #ff3c73, #ffbb00);
  }
}

.borderBg:active {
  background-image: linear-gradient(90deg, #ff004b, #ff8200);

  .itemBg15 {
    background: linear-gradient(45deg, #ff004b 0%, #ff8200 100%);
  }
}

.dark {
  .borderBg {
    border: solid 1px transparent;
    background-origin: border-box;
    background-clip: content-box, border-box;
    background-image: linear-gradient(#242529, #242529), linear-gradient(90deg, #ff64a5, #fcd535);
  }

  .borderBg:hover {
    .itemBg15 {
      background: linear-gradient(90deg, #ff64a5, #fcd535);
    }
  }
}
</style>
